import {Component, Input, OnInit} from '@angular/core';
import {HEISHI_TOUTA_PROPERTIES, KEISHAHIBETSUFILE_PROPERTY} from '../../constants';
import {CommonService} from '../../../core/service/common.service';
import {ShiyoulotService} from '../../../core/service/shiyoulot.service';
import {MasterService} from '../../../core/service/master.service';
import {KeishaHibetsuFile} from '../../interfaces/keisha-hibetsu-file';

@Component({
  selector: 'app-keisha-hibetsu-info',
  templateUrl: './keisha-hibetsu-info.component.html',
  styleUrls: ['./keisha-hibetsu-info.component.scss']
})
export class KeishaHibetsuInfoComponent implements OnInit {
  @Input() selectedKeishaHibetsuFile?: KeishaHibetsuFile;
  heishiToutaProperties = HEISHI_TOUTA_PROPERTIES;
  temperature = KEISHAHIBETSUFILE_PROPERTY.INTERFIX.TEMPERATURE;
  constructor(public shiyoulotService: ShiyoulotService,
              public masterService: MasterService,
              public commonService: CommonService) { }

  /**
   *
   */
  ngOnInit(): void {
  }
}
